import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react'
import { useFacetsBuildQuery } from './hooks'
import { clone, get, includes, pull } from 'lodash'

const SearchContext = createContext({})

export const useSearchBook = () => {
  return useContext(SearchContext)
}

export const SearchProvider = ({ children }) => {
  const [facetState, setFacetState] = useState({})

  const { searchFilters: filtersQuery } = useFacetsBuildQuery(facetState)

  const handleFacet = useCallback((facetName, attribute) => {
    setFacetState((state) => {
      const facetValues = clone(get(state, facetName, []))
      const nextState = { ...state, [facetName]: facetValues }

      if (!includes(facetValues, attribute)) facetValues.push(attribute)
      else pull(facetValues, attribute)

      return nextState
    })
  }, [])
  const handlFacetReset = useCallback(() => {
    setFacetState({})
  }, [])

  const status = useMemo(
    () => ({
      handleFacet,
      handlFacetReset,
      facetState,
      filtersQuery,
      setFacetState,
    }),
    [filtersQuery]
  )

  return (
    <SearchContext.Provider value={status}>{children}</SearchContext.Provider>
  )
}
